import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonNew as Button } from "components/buttonNew";
import { KioskBookingDetailsCard } from "./KioskBookingDetailsCard";
import { KioskHelpFooter } from "./KioskHelpFooter";
import { IBooking } from "redux/reducers/models/teetime";
import { ICustomer } from "redux/reducers/models/customer";

interface IKioskConfirmDetailsProps {
  booking: IBooking | null;
  customer: Partial<ICustomer> | null;
  searchType: string;
  setCustomer: (customer: Partial<ICustomer> | null) => void;
  onConfirm: () => void;
  onCancel: () => void;
  onTimeout?: () => void;
}

export function KioskConfirmDetails({
  booking,
  customer,
  searchType,
  setCustomer,
  onConfirm,
  onCancel,
  onTimeout,
}: IKioskConfirmDetailsProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (onTimeout) {
        onTimeout();
      } else {
        onCancel();
      }
    }, 25000);

    return () => clearTimeout(timer);
  }, [onCancel, onTimeout]);


  return (
    <div className="ui-kiosk-container">
      <img src="../../../../public/images/Tee-On.png" alt="teeon.com" className="ui-kiosk-logo" />

      <p className="ui-kiosk-title">{t("Confirm booking details")}</p>

      <p className="ui-kiosk-subtitle">{t("Please verify if your booking details are correct.")}</p>

      <KioskBookingDetailsCard
        booking={booking}
        customer={customer}
        searchType={searchType}
        setCustomer={setCustomer}
      />

      <div className="ui-kiosk-button-container">
        <Button onClick={onConfirm} type="primary" className="ui-kiosk-button">
          {t("Confirm check-in")}
        </Button>

        <Button onClick={onCancel} type="secondary" className="ui-kiosk-button ml-0">
          {t("Go back")}
        </Button>

        <KioskHelpFooter />
      </div>
    </div>
  );
}
